import update from 'immutability-helper';
import moment from "moment";

import {
    LOAD_CONTAS_RECEBER,
    CREATE_CONTA_RECEBER,
    UPDATE_CONTA_RECEBER,
    DELETE_CONTA_RECEBER,
    MARK_AS_RECEIVED,
} from './actions';

export var defaultState = {
    data: [],
    summary: {
        total: 0, pending: 0, paid: 0, overdue: 0,
        count_total: 0, count_pending: 0, count_paid: 0, count_overdue: 0,
    },
    filter: {
        from: moment().startOf("month").format("YYYY-MM-DD"),
        to: moment().endOf("month").format("YYYY-MM-DD"),
        status: "all",
    },
    isLoading: false,
};

var ACTION_HANDLERS = {
    [LOAD_CONTAS_RECEBER.INIT]: function(state) {
        return update(state, { isLoading: { $set: true } });
    },
    [LOAD_CONTAS_RECEBER.SUCCESS]: function(state, action) {
        return update(state, {
            isLoading: { $set: false },
            data: { $set: action.payload.data.data.records },
            summary: { $set: action.payload.data.data.summary },
            filter: { $set: action.meta.previousAction.payload.filter },
        });
    },
    [LOAD_CONTAS_RECEBER.FAIL]: function(state) {
        return update(state, { isLoading: { $set: false } });
    },
    [CREATE_CONTA_RECEBER.SUCCESS]: function(state, action) {
        return update(state, { data: { $unshift: [action.payload.data.data] } });
    },
    [UPDATE_CONTA_RECEBER.SUCCESS]: function(state, action) {
        var rec = action.payload.data.data;
        return update(state, {
            data: { $set: state.data.map(function(item) { return item.id === rec.id ? rec : item; }) },
        });
    },
    [DELETE_CONTA_RECEBER.SUCCESS]: function(state, action) {
        var id = action.meta.previousAction.id;
        return update(state, {
            data: { $set: state.data.filter(function(item) { return item.id !== id; }) },
        });
    },
    [MARK_AS_RECEIVED.SUCCESS]: function(state, action) {
        var rec = action.payload.data.data;
        return update(state, {
            data: { $set: state.data.map(function(item) { return item.id === rec.id ? rec : item; }) },
        });
    },
};

export default function(state, action) {
    if (state === undefined) state = defaultState;
    var handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};
